// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".productGrid{display:flex;flex-wrap:wrap;margin-left:-8px;margin-right:-8px}.productGrid__tile{flex:0 0 33.333%;height:auto;margin-bottom:16px;max-width:33.333%;padding-left:8px;padding-right:8px}@media(max-width:1280px){.productGrid__tile{flex:0 0 50%;max-width:50%}}@media(max-width:600px){.productGrid__tile{flex:0 0 100%;max-width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
